import React from 'react';

import { CircularProgress, Typography } from '@mui/material';

export default function Loader({ isOpen, size, backdropColor, message }) {
  if (!isOpen) {
    return <></>;
  }

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        backgroundColor: backdropColor || 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 99999999,
        borderRadius: '5px',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress
          size={size || 36}
          sx={{
            top: -6,
            left: -6,
            zIndex: 1,
            color: '#FF851B',
          }}
        />
        <Typography
          variant="body2"
          gutterBottom
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            color: '#fff',
            paddingTop: '10px',
          }}
        >
          {message}
        </Typography>
      </div>
    </div>
  );
}
